import { createSelector } from 'reselect';

export const selectProfilesSlice = state => state.profiles;

export const selectProfiles = createSelector(
  selectProfilesSlice,
  slice => slice.profiles
);
export const profilesLoaded = createSelector(
  selectProfilesSlice,
  slice => slice.profilesLoaded
);
export const selectActiveProfile = createSelector(
  selectProfilesSlice,
  slice => slice.activeProfile
);

export const profilesMeta = createSelector(
  selectProfilesSlice,
  slice => slice.meta
);
export const profilesFilters = createSelector(
  selectProfilesSlice,
  slice => slice.filters
);

export const profileCreating = createSelector(
  selectProfilesSlice,
  slice => slice.isCreating
);
export const profileUpdating = createSelector(
  selectProfilesSlice,
  slice => slice.isUpdating
);
export const profileDeleting = createSelector(
  selectProfilesSlice,
  slice => slice.isDeleting
);
export const profilesErrors = createSelector(
  selectProfilesSlice,
  slice => slice.errors
);
